import React from 'react';
import { Core_Bump_Recommendation_ListingQuery } from '@reverbdotcom/commons/src/gql/graphql';
import { BumpModalBodyTopPickIteration } from './BumpModalBodyTopPickIteration';
import { RCLoadingBars } from '@reverbdotcom/cadence/components';

export interface BumpRecommendationBodyProps {
  bid: number;
  selectedBid: number;
  handleBidChange: (bid: number) => void;
  successMessage: string;
  failMessage: string;
  onSubmit: () => void;
  // Hides the body's inline submit button, for consumers rendering their own.
  hideSubmit?: boolean;
  // Hides the body's success confirmation, for consumers that close on success
  // (where it would only flash) or that report success on their own surface.
  hideSuccessMessage?: boolean;
  showCustomWarning: boolean;
  setShowCustomWarning: React.Dispatch<React.SetStateAction<boolean>>;
  listing?: Core_Bump_Recommendation_ListingQuery['listing'];
  bumpRecommendationAmount: number | null;
  listingLoading?: boolean;
  showTopPickVariant?: boolean;
}

export function BumpRecommendationBody(props: BumpRecommendationBodyProps) {
  if (props.listingLoading || !props.listing || props.bumpRecommendationAmount === null) {
    return <div className="d-flex fx-justify-center padding-4"><RCLoadingBars /></div>;
  }

  return (
    <BumpModalBodyTopPickIteration
      recommendationAmount={props.bumpRecommendationAmount}
      listing={props.listing}
      bid={props.bid}
      selectedBid={props.selectedBid}
      handleBidChange={props.handleBidChange}
      successMessage={props.hideSuccessMessage ? '' : props.successMessage}
      failMessage={props.failMessage}
      hideSubmit={props.hideSubmit}
      onSubmit={props.onSubmit}
      showCustomWarning={props.showCustomWarning}
      setShowCustomWarning={props.setShowCustomWarning}
      minimumBumpBid={0}
      showTopPickVariant={props.showTopPickVariant}
    />
  );
}

export default BumpRecommendationBody;
